import React from 'react';
import { ClipboardList } from 'lucide-react';
import { BaseSidebar, NavigationItem } from './BaseSidebar';

interface DiligenciasManagerSidebarProps {
  onSidebarToggle?: (open: boolean) => void;
}

export const DiligenciasManagerSidebar: React.FC<DiligenciasManagerSidebarProps> = ({
  onSidebarToggle,
}) => {
  const navigationItems: NavigationItem[] = [
    {
      label: 'Diligências',
      href: '/diligencias-manager/diligencias',
      icon: <ClipboardList className="text-sidebar-foreground size-4 shrink-0" />,
    },
  ];

  return (
    <BaseSidebar
      navigationItems={navigationItems}
      profilePath="/diligencias-manager/profile"
      onSidebarToggle={onSidebarToggle}
    />
  );
};
